import { createContext } from 'react';

type PropsCelsiusAiContext = {
  isCelsiusOpen: boolean,
  setIsCelsiusOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const DEFAULT_VALUE: PropsCelsiusAiContext = {
  isCelsiusOpen: false,
  setIsCelsiusOpen: () => {},
};

const CelsiusAiContext = createContext<PropsCelsiusAiContext>(DEFAULT_VALUE);

export default CelsiusAiContext;
